import React from 'react';
import * as _ from 'lodash';

import { LaborSafetySearchForm } from '../components/searchmenus/LaborSafety';
import { SubcontractorsTableContents } from '../components/tables/SubcontractorsTable';

import { FieldTreeOperatableIdsDropdown } from '../components/dropdowns/multi/FieldTreeOperatableIds';

import { LaborSafetyService } from '../utilities/LaborSafety';

import InfinityScrollLoad from '../components/InfinityScrollLoad';

import Helmet from 'react-helmet';
import { HEADER_CONSTANTS } from '../utilities/constants';

@LaborSafetyService()
export class SubcontractorsTable extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      roleId: localStorage.getItem('role_id'),
      formCode: 5,
      search_form_open: false,
      formStatuses: [],
      total: 0,
      field_tree_id: [],
      field_tree_id_prime: [],
      searchParams: {
        status: null,
        field_tree_ids: [],
      },
      refresh: false,
      loaded: false,
    };
    this.events = {
      searchform: {
        search: this.onChangeSearchParams.bind(this),
        clear: this.onClearSearchParams.bind(this),
        dropdown: this.setMultiCondition.bind(this),
      },
    };
  }

  componentDidMount() {
    this.getFormStatuses();
  }

  onChangeSearchParams(e) {
    const searchParams = this.state.searchParams;
    searchParams[e.target.name] = e.target.value;
    this.setState({ searchParams });
    this.getFormStatuses(searchParams);
  }

  setMultiCondition = (name, selected) => {
    let state = this.state;
    state[name] = selected;
    state.searchParams.field_tree_ids = _.concat(
      state.field_tree_id,
      state.field_tree_id_prime
    );
    state.searchParams.field_tree_ids = state.searchParams.field_tree_ids.filter(
      function(x, i, self) {
        return self.indexOf(x) === i;
      }
    );
    this.getFormStatuses(state.searchParams);
  };

  onClearSearchParams() {
    let state = this.state;
    state.searchParams = {
      status: null,
      field_tree_ids: null,
    };
    state.field_tree_id = null;
    state.field_tree_id_prime = null;
    state.refresh = true;
    this.setState(state);
    this.getFormStatuses(state.searchParams);
  }

  render() {
    return (
      <div id='main' className='main'>
        <Helmet>
          <title>{HEADER_CONSTANTS.rouan} - 下請負業者編成表</title>
        </Helmet>
        <div className='main__header'>
          <h1>下請負業者編成表</h1>
        </div>
        <div id='infinityscroll-target' className='main__body'>
          <div className='gate-schedulelist'>
            <LaborSafetySearchForm
              onOpen={() =>
                this.setState({
                  search_form_open: !this.state.search_form_open,
                })
              }
              isOpen={this.state.search_form_open}
              callbacks={this.events}
              total={this.state.total}
            >
              <Status
                searchParams={this.state.searchParams}
                callbacks={this.events}
              />
              <OperatableIds
                callbacks={this.events.searchform.dropdown}
                selectedValues={this.state.field_tree_id}
              />
            </LaborSafetySearchForm>
            <SubcontractorsTableContents
              vw={this.props.vw}
              contents={this.state.formStatuses}
              canDrag={this.state.canDrag}
              infinityScrollLoad={
                <InfinityScrollLoad
                  targetId='infinityscroll-target'
                  total={_.size(this.state.formStatuses)}
                  callback={notifyEnd => {
                    this.getFormStatuses(this.state.searchParams, notifyEnd);
                  }}
                />
              }
            />
          </div>
        </div>
      </div>
    );
  }
}

const Status = ({ searchParams, callbacks }) => (
  <div className='form-element'>
    <div className='form-element__label'>
      <span className='label'>ステータス</span>
    </div>
    <div className='form-element__list'>
      <div className='element__item'>
        <label htmlFor='radio-status-1' className='radio'>
          <input
            id='radio-status-1'
            name='status'
            value={0}
            type='radio'
            checked={searchParams.status === '0'}
            onChange={e => callbacks.searchform.search(e)}
          />
          <i className='i-2x' />
          <span>未提出</span>
        </label>
      </div>
      <div className='element__item'>
        <label htmlFor='radio-status-2' className='radio'>
          <input
            id='radio-status-2'
            name='status'
            value={1}
            type='radio'
            checked={searchParams.status === '1'}
            onChange={e => callbacks.searchform.search(e)}
          />
          <i className='i-2x' />
          <span>未承認</span>
        </label>
      </div>
      <div className='element__item'>
        <label htmlFor='radio-status-3' className='radio'>
          <input
            id='radio-status-3'
            name='status'
            value={2}
            type='radio'
            checked={searchParams.status === '2'}
            onChange={e => callbacks.searchform.search(e)}
          />
          <i className='i-2x' />
          <span>承認済</span>
        </label>
      </div>
    </div>
  </div>
);

const OperatableIds = ({ onSelect, selectedValues }) => (
  <div className='form-element'>
    <div className='form-element__label'>
      <span className='label'>協力会社名</span>
    </div>
    <FieldTreeOperatableIdsDropdown
      selectedValues={selectedValues}
      onSelect={onSelect}
    />
  </div>
);



// WEBPACK FOOTER //
// ./src/pages/SubcontractorsTable.jsx